var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-grid kt-grid--ver kt-grid--root"},[_c('div',{staticClass:"kt-grid__item kt-grid__item--fluid kt-grid kt-error-v6",style:({
      backgroundImage: `url(${_vm.backgroundImage})`,
    })},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-error_container"},[_c('div',{staticClass:"kt-error_subtitle kt-font-light"},[_c('h1',[_vm._v("Oops...")])]),_c('p',{staticClass:"kt-error_description kt-font-light"},[_vm._v(" Looks like something went wrong."),_c('br'),_vm._v(" We're working on it ")])])
}]

export { render, staticRenderFns }